function toggleProductCount(hasSizeFilersActive) {
	const productCount = document.querySelector('.product-count');
	if (productCount) {
		if (hasSizeFilersActive) {
			productCount.classList.add('u-hidden');
		} else {
			productCount.classList.remove('u-hidden');
		}
	}
}

function updateProductCount(event) {
	const form = event.detail.form;
	const url = event.detail.url || '';
	if (form) {
		const formData = new FormData(form);
		let hasSizeFilersActive = false;
		for (const key of formData.keys()) {
			if (key.includes('size')) {
				hasSizeFilersActive = true;
				break;
			}
		}
		toggleProductCount(hasSizeFilersActive);
	} else {
		toggleProductCount(url.includes('size') || url.includes('talla'));
	}
}

document.body.addEventListener('filters:update', updateProductCount);
